// this is the list of all the metrics we use in the chart
export enum Metrics {
  score = 'overall',
  stress = 'stress',
  ibsScore = 'ibs_score',
  upperGIScore = 'upper_gi_score',
  ucScore = 'uc_score',
  cdScore = 'cd_score',
}

// Tells how many days of data from today we want to look at in the past;
// '0' stands for all the available data with no limitation.
export type DataRange = 0 | 30 | 90;
